/* eslint-disable */
const getRandomId = (prefix: string | null = null) => `${prefix || ''}${Buffer.from(JSON.stringify(Math.random() * 999999999 - Math.random() * 99999999), 'utf-8').toString('base64')}`;

export {
  getRandomId,
};
